/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { etoileProgrammes, defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_046: Question = {
  id: 'pres-046-programmes-sensibilisation-eee',
  oldId: '60',
  title: 'Nombre total de programmes de sensibilisation',
  number: '4.8',
  description: [''],
  type: QuestionType.INDICATOR,
  frequency: 1,
  slots: [
    {
      type: SlotTypes.ETOILES,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      scoringFct: (data:number) => {
        if (data >= 2) return 3;
        if (data >= 1) return 2;
        return 0;
      },
      score: '0',
      maxScore: 3,
      help: etoileProgrammes,
      unit: SlotUnit.NUMBER_OF,
    },
  ],
};

const question_pres_046__v3: Question = {
  ...question_pres_046,
  type: QuestionType.ACTIVITY,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      scoringFct: (data: string[]) => parseFloat(data[0]),
      score: '0',
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

export const question_pres_046_v2: Question = question_pres_046;
export const question_pres_046_v3: Question = question_pres_046__v3;
